// plan-01 S04: typed event bus — plans 03+ extend EventMap via module augmentation

export interface EventMap {
  'oracle.command': { cmd: string; args: string[] }
  'oracle.stream': { text: string; cls?: string }
  'oracle.log': { text: string }
  'oracle.fxCue': { cue: string }
  'oracle.mode': { from: string; to: string }
  'stage:changed': { id: string | null }
  'network:online': Record<string, never>
  'network:offline': Record<string, never>
  'vitals:tick': Record<string, never>
  'filesystem:play': { path: string; displayName: string }
}

type Handler<T> = (payload: T) => void

const handlers = new Map<string, Set<Handler<unknown>>>()

export function on<E extends keyof EventMap>(
  event: E,
  handler: Handler<EventMap[E]>,
): () => void {
  let set = handlers.get(event as string)
  if (!set) {
    set = new Set()
    handlers.set(event as string, set)
  }
  set.add(handler as Handler<unknown>)
  return () => set!.delete(handler as Handler<unknown>)
}

export function emit<E extends keyof EventMap>(
  event: E,
  payload: EventMap[E],
): void {
  handlers.get(event as string)?.forEach((h) => h(payload))
}
